import { Search, Filter, ArrowUpDown } from "lucide-react"

export function CommunityFilters({
  categories,
  selectedCategory,
  setSelectedCategory,
  searchQuery,
  setSearchQuery,
  sortOptions,
  selectedSort,
  setSelectedSort,
  resultsCount,
}) {
  return (
    <div className="space-y-6">
      {/* Search and Sort Controls */}
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            type="search"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-200  bg-white  focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
          />
        </div>

        <div className="flex gap-3 flex-shrink-0">
          <select
            value={selectedSort}
            onChange={(e) => setSelectedSort(e.target.value)}
            className="px-4 py-3 rounded-lg border border-gray-200  bg-white  focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
          >
            {sortOptions.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </select>
          <button className="inline-flex items-center px-4 py-3 bg-white  border border-gray-200  rounded-lg hover:bg-gray-50  transition-colors shadow-sm">
            <Filter className="w-5 h-5 mr-2" />
            Filters
          </button>
        </div>
      </div>

      {/* Category Filters */}
      <div className="flex overflow-x-auto pb-2 -mx-2 px-2 scrollbar-hide gap-3">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => setSelectedCategory(category.id)}
            className={`
              flex items-center px-4 py-2.5 rounded-lg whitespace-nowrap transition-colors text-sm font-medium
              ${
                selectedCategory === category.id
                  ? "bg-indigo-600 text-white shadow-md"
                  : category.color || "bg-white  text-gray-700  shadow-sm"
              }
            `}
          >
            {category.name}
          </button>
        ))}
      </div>

      {/* Results count */}
      {resultsCount !== undefined && (
        <div className="flex items-center justify-between">
          <p className="text-gray-500 ">
            Showing <span className="font-medium text-gray-900 ">{resultsCount}</span> results
          </p>
          <button className="flex items-center text-sm text-gray-500 hover:text-indigo-600 transition-colors">
            <ArrowUpDown className="w-4 h-4 mr-1" />
            Toggle view
          </button>
        </div>
      )}
    </div>
  )
}

